import { render, staticRenderFns } from "./LayoutPublic.vue?vue&type=template&id=90f4fa64&scoped=true&"
import script from "./LayoutPublic.vue?vue&type=script&lang=ts&"
export * from "./LayoutPublic.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutPublic.vue?vue&type=style&index=0&id=90f4fa64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f4fa64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VAppBar,VContainer,VFooter,VImg,VMain,VToolbarTitle})
